export enum DisplayMode {
  real = 'real',
  mix = 'mix',
  budget = 'budget'
}
